import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";

import useSurvey from "../../hooks/useSurvey";
import useOrder from "../../hooks/useOrder";

import Loading from "./Loading";
import OrderForm from "./OrderForm";

const OrderEntry = ({ surveyId, callId, mode, onClose }) => {
  const { survey, clearOrderEntry, prepareOrderEntry, skuList, order } =
    useSurvey();
  const { saveOrder } = useOrder();

  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (mode === "view") {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
    prepareOrderEntry(callId, surveyId);
  }, []);

  useEffect(() => {
    console.log({ order });
    if (!order) return;

    if (mode === "edit" && Boolean(order.sentAt)) {
      setReadOnly(true);
    }
  }, [order]);

  const handleBackToDocket = () => {
    onClose();
  };

  const handleSave = async (updatedOrder) => {
    // save logic here
    await saveOrder(updatedOrder);
    handleBackToDocket();
  };

  const handleCancel = async () => {
    handleBackToDocket();
  };

  if (!order || !survey || !skuList) return <Loading />;

  return (
    <Box sx={{ flex: 1 }}>
      <OrderForm
        title={survey.name}
        order={order}
        skuList={skuList || []}
        onSave={handleSave}
        onCancel={handleCancel}
        readOnly={readOnly}
      />
    </Box>
  );
};

export default OrderEntry;
